import { type FieldValidator, type PrimitiveField, type ValidationError } from '@adv-frontend/form-kit';

/*
 * Создает валидатор, проверяющий, что значение является датой после вчерашнего дня
 *
 * @param code код ошибки
 * @returns валидатор
 */
export function dateAfterYesterdayValidator<
    Code extends string,
    FieldValue extends string,
    FieldContextInput,
    FieldContext,
    FieldActions,
    FieldSelectors,
>(
    code: Code
): FieldValidator<
    PrimitiveField<FieldValue, ValidationError<Code>, FieldContextInput, FieldContext, FieldActions, FieldSelectors>
> {
    return (value, fieldApi) => {
        const today = new Date();
        const date = new Date(value);

        if (date.toDateString() !== today.toDateString() && date < today) {
            fieldApi.addValidationError({
                code,
            });
        }
    };
}
